import { DataField } from "./datafield";

export class DataFieldValue {
    constructor(
        public CallbackReferenceId?: string | number,
        public Value?: string, public Secret?: string) {
    }

    /**
    * The Secret field is used only for password fields, where it contains the actual password and the
    * Value field contains the secret id (if one exists, or blank when the secret is not yet persisted).
    */

    public static FromDataField(dataField: DataField): DataFieldValue {
        if (dataField.DataType.DataTypeEnum.toString() == 'Password' || dataField.DataType.DataTypeName == 'Password') {
            return new DataFieldValue(dataField.CallbackReferenceId, dataField.SecretId, dataField.Value);
        }

        return new DataFieldValue(dataField.CallbackReferenceId, dataField.Value)
    }
}
